<template>
  <div class="row">
    <q-card
      flat
      v-if="extended"
      class="q-mx-xs q-pa-xs q-mb-xs text-red text-caption cursor-pointer"
      :class="$q.dark.mode === true ? 'bg-grey-10' : 'bg-red- '"
      @click="this.$router.push({ path: '/disclaimer' })"
    >
      *DISCLAIMER: Signals from Chukul are not Buy-Sell recommendations. Chukul
      is not responsible for profit or loss of investors. Investors should make
      their own decisions.
      <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
        <strong>Click</strong> to read <em>disclaimer</em> (<q-icon
          name="warning"
        />)
      </q-tooltip>
    </q-card>
    <q-card
      flat
      v-if="short"
      class="q-mx-xs q-mb-xs q-pa-xs text-red text-caption cursor-pointer"
      :class="$q.dark.mode === true ? 'text-red' : 'bg-red- '"
      @click="this.$router.push({ path: '/disclaimer' })"
    >
      *DISCLAIMER: Signals from Chukul are not Buy-Sell Recommendations.
      <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
        <strong>Click</strong> to read <em>disclaimer</em> (<q-icon
          name="warning"
        />)
      </q-tooltip>
    </q-card>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "DisclaimerMessage",

  props: {
    extended: {
      type: Boolean,
    },
    short: {
      type: Boolean,
    },
  },

  setup() {
    return {};
  },
});
</script>
